var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586a1.99 1.99 0 0 0-1.414-.586c-.534 0-1.036.208-1.413.585L4 13.585V18h4.413zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16zm-2 4h16v2H4z"
})));
export default SvgEditLine;